import { TALENTS, type TalentDef } from '@/models/talents';

export class TalentManager {
  private shards: number = 0;
  private levels: Record<string, number> = {};

  getShards(): number { return this.shards; }

  addShards(amount: number): void { this.shards += amount; }

  getTalentLevel(id: string): number { return this.levels[id] ?? 0; }

  getLevels(): Record<string, number> { return { ...this.levels }; }

  purchaseTalent(id: string): boolean {
    const def = TALENTS.find(t => t.id === id);
    if (!def) return false;
    const currentLevel = this.getTalentLevel(id);
    if (currentLevel >= def.maxLevel) return false;
    if (this.shards < def.shardCost) return false;
    this.shards -= def.shardCost;
    this.levels[id] = currentLevel + 1;
    return true;
  }

  getTalentEffect(effectType: TalentDef['effectType']): number {
    let total = 0;
    for (const t of TALENTS) {
      if (t.effectType === effectType) {
        total += (this.levels[t.id] ?? 0) * t.effectPerLevel;
      }
    }
    return total;
  }

  static calculateShardsForPrestige(totalProductionRate: number, prestigeBonus: number): number {
    if (totalProductionRate <= 0) return 0;
    return Math.floor(Math.sqrt(totalProductionRate / 100) * (1 + prestigeBonus));
  }

  restoreState(shards: number, levels: Record<string, number>): void {
    this.shards = shards;
    this.levels = { ...levels };
  }
}
